import clientConfigApi from '../config/config'
import { wipeGuestData } from '../JS/wipeGuestData'
import { getCurrentGuestDetails } from '../layout2.0/JS/utility'

export const getGuestInRoom = (guestDetail) => {
    return async dispatch => {
        let room = localStorage.getItem("room")
        room = room && room !== "null" ? room : "notLogin"
        try {
            if (guestDetail.guestToken && guestDetail.locationId) {
                clientConfigApi.post(
                    "/checkInGuestList/fetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
                    {
                        "payload": {},
                        "header": {
                            "locationId": guestDetail.locationId,
                            "guestToken": guestDetail.guestToken
                        },
                    }
                ).then((res) => {
                    console.log("res checkInGuestList", res);
                    if (res && res.data && res.data.payload && res.data.payload.guestDetails) {
                        let list = getCurrentGuestDetails(res.data.payload.guestDetails)

                        // dispatch({
                        //     type: 'Check_In_Guest_List',
                        //     payload: res.data.payload.guestDetails
                        // })
                        
                        // updated checkInGuestlist to only have loggedInGuest
                        dispatch({
                            type: 'Check_In_Guest_List',
                            payload: list
                        })
                        dispatch({
                            type: 'Set_Current_Logged_In_Guest_Details',
                            payload: list
                        })
                    }
                })
                    .catch(
                        ({ response = {} }) => {
                            console.log("checkInGuestList Api failed with the status code:", response.status);
                        }
                    )
            }
        } catch (e) {
            console.log(`error in api call to path= "/checkInGuestList/fetch"`, e);
        }
    }
}

export const getGuestRequestList = (guestDetail, groupID, callBackFunc) => {
    //console.log("guestDetail", guestDetail)
    return dispatch => {
        try {
            if (guestDetail.reservationNumber) {
                clientConfigApi.post(
                    "/serviceGroupDetails/get",
                    {
                        "header": { "serviceGroupId": groupID },
                        "payload": {}
                        // "header": {
                        //     "locationId": guestDetail.locationId,
                        //     "guestToken": guestDetail.guestToken
                        // },
                        // "payload": {
                        //     "qualityPlusReqGroupSku": sku
                        // }
                    }
                ).then((res) => {

                    console.log("res qualityPlusGroup", res);
                    if (res && res.data && res.data.payload ) {

                        let guestRequestDispatch;
                        if(Array.isArray(res.data.payload)){
                            // for multiple sku(s)
                            guestRequestDispatch= {
                                type: 'Guest_Request_List',
                                payload: {
                                    requestMaster: null,
                                    guestRequestOtherData: res.data.payload[0],
                                    groupedGuestRequestData:res.data.payload
                                }
                            }
                        } else if(res.data.payload.requestMaster) {
                            // for single sku
                            guestRequestDispatch= {
                                type: 'Guest_Request_List',
                                payload: {
                                    requestMaster: res.data.payload.requestMaster,
                                    guestRequestOtherData: res.data.payload,
                                    groupedGuestRequestData:null
                                }
                            }
                        }
                        dispatch(guestRequestDispatch)
                        callBackFunc(true)
                    } 

                })
                    .catch(
                        ({ response = {} }) => {
                            callBackFunc(false, "Failed to get the data")
                            if(response.status == 401){
                                wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                            }
                            console.log("qualityPlusGroup Api failed with the status code:", response.status);
                        }
                    )
            }
        } catch (e) {
            callBackFunc(false)
            console.log(`error in api call to path= "/fetchGuestReqURI"`, e);
        }
    }
}



export const saveGuestRequest = (guestDetail, sessionToken, guestRequests, textNote, callBack) => {
    let objToSend = [], obj
    guestRequests.map((iterator) => {
        obj = {
            "serviceRequestId": iterator,
            "quantity": 1,
            "additionalNote": textNote
        }
        objToSend.push(obj);
    })
    console.log("objToSend", objToSend, guestDetail.guestToken, guestDetail.location);
    return async dispatch => {
        try {
            if (guestDetail.reservationNumber) {
                console.log("calling qps")
                clientConfigApi.post(
                    "/qualityPlus/request",
                    {
                        "header": {
                            "sessionToken": sessionToken,
                            "guestToken": guestDetail.guestToken,
                            "locationId": guestDetail.location,
                            "loggedinGuestToken": guestDetail.guestToken,
                            "dataSource": "guestJourney"
                        },
                        "payload": {
                            "reservationNumber": guestDetail.reservationNumber,
                            "qualityPlusRequest": objToSend,
                            "sourceApp": "guestJourneyApp",
                            "platform": window.device ? window.device.platform : "Web",
                        }
                    }
                )
                    .then((res) => {
                        console.log("/qualityPlus/request success", res);
                        if(res.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        }
                        if (res && res.data && res.data.header
                            && res.data.header.status.code === "SUCCESS") {
                            /*dispatch({
                                type: 'Set_Submit_Request_Window_and_PopUP',
                                payload: {
                                    submitRequestWindow: false,
                                    successPopUP: true,
                                    msg: res.data.header.status.msg
                                }
                            })*/

                            callBack(true,res.data.header.status.msg)
                        }
                    })
                    .catch(
                        ({ response = {} }) => {
                            console.log("'/qualityPlus/request' Api failed with the status code:", response.status);
                            if(response.status == 401){
                                wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                            }
                            /*dispatch({
                                type: 'Set_Submit_Request_Window_and_PopUP',
                                payload: {
                                    submitRequestWindow: false,
                                    successPopUP: true,
                                    msg: "Request failed."
                                }
                            })*/
                            let message = (response.data && response.data.header && response.data.header.status && response.data.header.status.msg && response.data.header.status.msg)
                            callBack(false, message || "Request failed.")
                        }
                    )
            }
        } catch (e) {
            console.log(`error in api call to path= "/qualityPlus/request"`, e);
        }
    }
}

export const setSubmitRequestWindow = (status) => {
    return {
        type: 'Set_Submit_Request_Window',
        payload: status
    }
}

export const setRequestIDList = (IDList) => {
    console.log("IDList", IDList)
    return {
        type: 'Set_Request_ID_List',
        payload: IDList
    }
}

export const setGuestRequestList = (list) => {
    return{
        type: 'Guest_Request_List',
        payload: {
            requestMaster: list,
            guestRequestOtherData: null
        }
    }
}

export const getSurvey = (surveyId, callback) => {
    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('GuestJourneySessionToken')}` }
    };
    return async dispatch => {
        try {
                clientConfigApi.get(`/configsV2/fetch?type=guestSurvey&id=${surveyId}`,config)
                    .then((res) => {
                        if(res.status == 401){
                            wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                        } else {
                            dispatch({
                                type: "Set_Survey_Data",
                                payload: res.data.payload
                            })
                            callback(true)
                        }
                    })
                    .catch(
                        ({ response = {} }) => {
                            if(response.status == 401){
                                wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                            }
                            callback(false)
                        }
                    )
        } catch (e) {
            console.log(`error in api call to path= "/qualityPlus/request"`, e);
        }
    }
}